(function ($) {
  'use strict';

  function init() {
    if (!google || !google.maps) {
      return;
    }

    var map, mapOptions, route;

    mapOptions = {
      scrollwheel: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#e9e9e9' }, { lightness: 17 }],
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [{ color: '#f5f5f5' }, { lightness: 20 }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [{ color: '#ffffff' }, { lightness: 17 }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }, { lightness: 18 }],
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }, { lightness: 16 }],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#f5f5f5' }, { lightness: 21 }],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#dedede' }, { lightness: 21 }],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            { visibility: 'on' },
            { color: '#ffffff' },
            { lightness: 16 },
          ],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            { saturation: 36 },
            { color: '#333333' },
            { lightness: 40 },
          ],
        },
        { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ color: '#f2f2f2' }, { lightness: 19 }],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.fill',
          stylers: [{ color: '#fefefe' }, { lightness: 20 }],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }],
        },
      ],
    };

    map = new google.maps.Map(document.getElementById('gmap'), mapOptions);

    route = new google.maps.KmlLayer({
      map: map,
      url: $('[data-map-kml]').first().data('map-kml'),
    });

    $('[data-map-kml]').first().addClass('active');

    if (!$('[data-map-kml]').first().data('map-kml')) {
      $('.field-route .responsive-container').fadeOut('fast');
    }

    $('[data-map-kml]').on('click', function (e) {
      $('[data-map-kml]').removeClass('active');
      $(this).addClass('active');

      if (!$(this).data('map-kml')) {
        $('section.routes .map').fadeOut('fast');
      } else {
        $('section.routes .map').fadeIn();
      }

      route.setMap(null);

      route = new google.maps.KmlLayer({
        map: map,
        url: $(this).data('map-kml'),
      });

      e.preventDefault();
    });
  }

  if (document.mapsApiLoaded) {
    init();
  } else if (document.addEventListener) {
    document.addEventListener('mapsApiLoaded', init);
  }
}).bind(window)(jQuery);
